<script setup lang="ts">
import { computed } from 'vue';

import { DateFormat, SemboDate } from '@libs/sembo-dates';

interface DayShortNameProps {
  date: Date;
}

const props = defineProps<DayShortNameProps>();

const dayShortName = computed<string>(() =>
  new SemboDate(props.date).format(DateFormat.ShortDayName)
);
</script>

<template>
  <span class="date-short-name">{{ dayShortName }}</span>
</template>

<style lang="scss" scoped>
.date-short-name {
  @include font-label-s-light;
  padding: var(--spacing-8);
}
</style>
